import React ,{useRef ,useEffect}from 'react';
import moment from 'moment'
import DynamicInputList from '../software-dynamic-version-5/list-input-v-5';
import SecurityService from '../security/security.service';

import InvoiceAdd  from './sale-invoice-add'
import SaleInvoiceService from './sale-invoice.service';

import { QRCodeGenerator } from '@syncfusion/ej2-barcode-generator';
import DialogInput from '../software-dynamic-version-5/popup-dialog-input-v-5';
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import './sale-invoice-list.scss'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import securityService from '../security/security.service';
// const DialogSelf = ()=>{return(<div></div>)}
let invoiceDetails={}
const SaleInvoiceInput = (props) => {

  console.log(props)

  // SaleInvoiceID	
  
  // invoiceDate	
  // sellerNTNCNIC	
  // buyerNTNCNIC	
  // invoiceRefNo	
  // scenarioId
  
    // let columns =[
    //     {  field: "SaleInvoiceID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[]},
    //     {  field: "invoiceDate",headerText:'Date',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
    //     {  field: "docDescription",headerText:'doc Description',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
    //     {  field: "sellerNTNCNIC",headerText:'seller NTN CNIC',width:'160px',textAlign:'left' ,headerTextAlign:'center',other:[]},
    //     {  field: "buyerNTNCNIC",headerText:'buyer NTN CNIC',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{}]},
        
    //     {  field: "invoiceRefNo",headerText:'invoice Ref No',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{}]},
    //     {  field: "scenarioId",headerText:'scenario Id',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{}]},
    //     ]


 
    let columns = [
      { field: "SaleInvoiceID", headerText: "Inv. ID", width: "90px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "invoiceDate", headerText: "Invoice Date", width: "140px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "docDescription", headerText: "Document Description", width: "160px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "FBRSaleInvoiceDetailNo", headerText: "FBR Sale Invoice", width: "220px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "sellerBusinessName", headerText: "Seller Name", width: "200px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "sellerNTNCNIC", headerText: "Seller NTN/CNIC", width: "160px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "sellerProvince", headerText: "Seller Province", width: "140px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "sellerAddress", headerText: "Seller Address", width: "220px", textAlign: "left", headerTextAlign: "center", other: [] },
    
      { field: "buyerNTNCNIC", headerText: "Buyer NTN/CNIC", width: "160px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "buyerBusinessName", headerText: "Buyer Name", width: "200px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerProvince", headerText: "Buyer Province", width: "140px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerAddress", headerText: "Buyer Address", width: "320px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerRegistrationType", headerText: "Buyer Type", width: "120px", textAlign: "center", headerTextAlign: "center", other: [] },
    
      { field: "invoiceRefNo", headerText: "Invoice Ref No", width: "140px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "scenarioId", headerText: "Scenario ID", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{visible:props?.path == "/SaleInvoiceSandbox"}] },
    
      { field: "hsCode", headerText: "HS Code", width: "120px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "productDescription", headerText: "Product Description", width: "200px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "rate", headerText: "Rate", width: "120px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "uoM", headerText: "UOM", width: "100px", textAlign: "center", headerTextAlign: "center", other: [] },

      { field: "quantity", headerText: "Quantity", width: "130px", textAlign: "right", headerTextAlign: "center", other: [{format:'n2'}] },
      { field: "valueSalesExcludingST", headerText: "Value of Sales Excl. ST", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "salesTaxApplicable", headerText: "Sales Tax", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n2'}] },
      
      { field: "fixedNotifiedValueOrRetailPrice", headerText: "Fixed/Notified Value of Retail Price", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "salesTaxWithheldAtSource", headerText: "ST Withheld At Source", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n2'}] },
      { field: "extraTax", headerText: "Extra Tax", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      
      { field: "furtherTax", headerText: "Further Tax", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "fedPayable", headerText: "FED Payable", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "discount", headerText: "Discount", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "totalValues", headerText: "Total Value", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{format:'n2'}] },


      { field: "sroScheduleNo", headerText: "SRO Schedule No", width: "140px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "sroItemSerialNo", headerText: "SRO Item Serial No", width: "140px", textAlign: "center", headerTextAlign: "center", other: [] },

 
      // { field: "transactioN_Desc", headerText: "Transaction Description", width: "200px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "saleType", headerText: "Sale Type", width: "250px", textAlign: "center", headerTextAlign: "center", other: [] },
      
    ];
        const getDetail = (data) =>{
          invoiceDetails = data
        }
       
       
       
        // if(args.requestType == 'add'){
        //   setTimeout(()=>document.getElementById('CountGridCountName').focus(),400)
        // }
        // document.getElementById('CountGridCountName').addEventListener('blur', async (e)=>{
        //   setTimeout(() => document.getElementById('CountGridCountName') && grid?.endEdit(), 200);
         
        // })
      

        const listActionComplete = async (
          grid,
          args,
          getListService,
          selectedRow,
          setDataSourceState,
          addUserLog,
          editUserLog
        ) => {
          console.log(args);
          console.log(getListService);
          console.log(selectedRow);
        
          if (args.requestType === 'beginEdit' || args.requestType === 'add') {
            // You can add any initialization logic here if needed
            // clearToasts()
          }
        
          if (args.requestType === 'save' || args.requestType === 'cancel') {
            getListService();
          }
        
          if (args.requestType === 'save') {
            console.log(invoiceDetails);
        
            // Validate invoice data
            
            let validateResponse =  props?.path == "/SaleInvoiceSandbox"  ? await SaleInvoiceService.validatePostDataTesting(
              args.data.CompanyID,
              invoiceDetails
            )   : await SaleInvoiceService.validatePostData(
              args.data.CompanyID,
              invoiceDetails
            );
            console.log(validateResponse);
        
            // If action is 'add', prepare data and insert
            if (args.action === 'add' && validateResponse?.data?.validationResponse?.invoiceStatuses[0].status == "Valid") {
              const mainData = {
                docDescription: invoiceDetails.invoiceType,
                invoiceDate: invoiceDetails.invoiceDate,
                sellerNTNCNIC: invoiceDetails.sellerNTNCNIC,
                buyerNTNCNIC: invoiceDetails.buyerNTNCNIC,
                invoiceRefNo: args.data.invoiceRefNo || '', // optional
                scenarioId: invoiceDetails.scenarioId,
                SaleInvoiceJSON: JSON.stringify(invoiceDetails),
              };
        
              const detailItems = invoiceDetails.items.map((item) => ({
                hS_CODE: item.hsCode,
                productDescription: item.productDescription,
                rate: item.rate,
                uoM: item.uoM,
                quantity: item.quantity,
                totalValues: item.totalValues,
                valueSalesExcludingST: item.valueSalesExcludingST,
                fixedNotifiedValueOrRetailPrice: item.fixedNotifiedValueOrRetailPrice,
                salesTaxApplicable: item.salesTaxApplicable,
                salesTaxWithheldAtSource: item.salesTaxWithheldAtSource,
                extraTax: item.extraTax,
                furtherTax: item.furtherTax,
                sroScheduleNo: item.sroScheduleNo,
                fedPayable: item.fedPayable,
                discount: item.discount,
                transactioN_Desc: item.saleType,
                sroItemSerialNo: item.sroItemSerialNo,
              }));
        
              const dataToInsert = {
                 ...mainData,
                details: detailItems,
              };
        
              try {
                const insertResponse = await SaleInvoiceService.insert(dataToInsert);
                console.log('Insert response:', insertResponse);
                getListService(); // Refresh list after insert
              } catch (error) {
                console.error('Insert failed:', error);
              }
            }
          }
        };
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = true
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default Count${typeMode} 
        let ListSecurity= props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`
        let AddSecurity= props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`
        let EditSecurity= props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`
        let DeleteSecurity= props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      // let toolbarOptions ='All';


      let toolbarOptions = [ {
        text: " Add Invoice For FBR", tooltipText: "Add Invoice For FBR", id: "Add", disabled:false
      },
        // {
        //   text: "Edit", tooltipText: "Edit", id: "EditRow", disabled:!EditSecurity, prefixIcon: "e-icons e-edit"

        // },
        // {
        //   text: "Delete", tooltipText: "Delete", id: "Delete", disabled:!DeleteSecurity
        // },
        {
          text: "delete", tooltipText: "Delete Row", id: "RowDelete", disabled:!DeleteSecurity,
          prefixIcon: "e-icons e-delete"
        },
        {
          text: "Preview A", tooltipText: "Sale Invoice Preview", id: "SaleInvoicePreview", disabled:false ,prefixIcon: "e-icons e-view"
        },
        {
          text: "Preview B", tooltipText: "Sale Invoice Preview 2 ", id: "SaleInvoicePreview2", disabled:false ,prefixIcon: "e-icons e-view"
        }
       
        ,'PDFExport','ExcelExport',
         {
          text: "Post Data", tooltipText: "Post Data", id: "PostData", disabled:false
        },
        'Search','ColumnChooser']
        let PostedToolbarOptions =[
             {
          text: "Preview", tooltipText: "Sale Invoice Preview", id: "SaleInvoicePreview", disabled:false ,prefixIcon: "e-icons e-view"
        },
        {
          text: "Preview 2", tooltipText: "Sale Invoice Preview 2 ", id: "SaleInvoicePreview2", disabled:false ,prefixIcon: "e-icons e-view"
        },
          'PDFExport','ExcelExport','Search','ColumnChooser'] 

   //  ===== GENERATING QR CODE ======
        function generateQRCodeBlob(value) {
          return new Promise((resolve) => {
            const container = document.createElement('div');
            container.style.position = 'absolute';
            container.style.left = '-9999px';
            container.style.width = '96px';
            container.style.height = '96px';
            document.body.appendChild(container);
        
            const qrCode = new QRCodeGenerator({
              width: '96px',
              height: '96px',
              value: value,
              mode: 'Canvas',
              backgroundColor: 'transparent',
              version: 2,
              displayText: { visibility: false },
              margin: { left: 0, right: 0, top: 0, bottom: 0 }
            });
        
            qrCode.appendTo(container);
        
            setTimeout(() => {
              const canvas = container.querySelector('canvas');
              if (canvas) {
      
                const jpegCanvas = document.createElement('canvas');
                jpegCanvas.width = canvas.width;
                jpegCanvas.height = canvas.height;
                const ctx = jpegCanvas.getContext('2d');
        
                // Optional: white background for JPEG
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, jpegCanvas.width, jpegCanvas.height);
        
                ctx.drawImage(canvas, 0, 0);
        
                jpegCanvas.toBlob((blob) => {
                  container.remove();
                  resolve(blob);
                }, 'image/jpeg', 1.0); // Quality: 1.0
              } else {
                container.remove();
                resolve(null);
              }
            }, 150);
          });
        }



        //  ==== CALL SALE INVOICE REPORT SERVICES ======

        function convertNumberToWords(num) {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
    "Eighty", "Ninety"
  ];
  const scales = [
    { value: 10000000, name: "Crore" },
    { value: 100000, name: "Lakh" },
    { value: 1000, name: "Thousand" },
    { value: 100, name: "Hundred" }
  ];

  function numberToWords(n) {
    if (n === 0) return "Zero";
    if (n < 20) return units[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "");

    for (let scale of scales) {
      if (n >= scale.value) {
        const quotient = Math.floor(n / scale.value);
        const remainder = n % scale.value;
        return (
          numberToWords(quotient) +
          " " +
          scale.name +
          (remainder ? " " + numberToWords(remainder) : "")
        );
      }
    }
    return "";
  }

  const whole = Math.floor(num);
  const fraction = Math.round((num - whole) * 100);

  let result = numberToWords(whole) + " Rupees";
  result += " and " + numberToWords(fraction) + " Paise";

  return result;
}
  //       function convertNumberToWords(num) {
  //         // const a = [
  //         //   "", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
  //         //   "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen",
  //         //   "sixteen", "seventeen", "eighteen", "nineteen"
  //         // ];
  //         // const b = [
  //         //   "", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy",
  //         //   "eighty", "ninety"
  //         // ];
        
  //         // const numberToWords = (n) => {
  //         //   if (n < 20) return a[n];
  //         //   if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? "-" + a[n % 10] : "");
  //         //   if (n < 1000)
  //         //     return a[Math.floor(n / 100)] + " hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
  //         //   if (n < 1000000)
  //         //     return numberToWords(Math.floor(n / 1000)) + " thousand" + (n % 1000 ? ", " + numberToWords(n % 1000) : "");
  //         //   return "amount too large";
  //         // };
        
  //         // return numberToWords(Math.floor(num)).replace(/\b\w/g, c => c.toUpperCase());

  //         fetch(`https://num2words.herokuapp.com/api/convert/${num}`)
  // .then(res => res.json())
  // .then(data => {
  //   console.log(data.words); // "Five million two hundred fifteen thousand nine hundred nine point nine"

  //   return data.words.replace(/\b\w/g, c => c.toUpperCase());

  // });
  //       }

  function getFormattedInvoiceRecords(id) {
    return SaleInvoiceService.getSaleInvoiceForList(id ,props?.path == "/SaleInvoiceSandbox" ? 0:1).then((response) => {
      const invoices = response.data.recordset;
  
      if (!invoices || invoices.length === 0) {
        console.log("No invoice data found.");
        return null;
      }
      
      
      let totalvalueSalesExcludingST = 0;
      let totalValues = 0;
      let totalSalesTax = 0;
      let totalFurtherTax = 0;
      let totalExtraTax = 0;
      let totalFedPayable = 0;
      let totalDiscount = 0;
      let totalQuantity = 0;
  
      const invoiceItems = invoices.map((item, idx) => {
        const itemTotal = item.totalValues || 0;
        const itemSalesTax = item.salesTaxApplicable || 0;
        const itemFurtherTax = item.furtherTax || 0;
        const itemExtraTax = item.extraTax || 0;
        const itemFedPayable = item.fedPayable || 0;
        const itemDiscount = item.discount || 0;
        const valueSalesExcludingST = item.valueSalesExcludingST || 0;
        const itemQuantity = item?.quantity || 0;
  
        totalvalueSalesExcludingST += valueSalesExcludingST;
        totalValues += itemTotal;
        totalSalesTax += itemSalesTax;
        totalFurtherTax += itemFurtherTax;
        totalExtraTax += itemExtraTax;
        totalFedPayable += itemFedPayable;
        totalDiscount += itemDiscount;
        totalQuantity += itemQuantity;
  
        return {
          srNo: idx + 1,
          FBRSaleInvoiceDetailNo: item.FBRSaleInvoiceDetailNo,
          description: item.productDescription,
          hsCode: item.hsCode,
          uoM: item?.uoM,
          quantity: itemQuantity,
          rate: item.rate,
          salesTax: itemSalesTax,
          extraTax: itemExtraTax,
          furtherTax: itemFurtherTax,
          fed: itemFedPayable,
          discount: itemDiscount,
          amount:valueSalesExcludingST ,
          totalInclTax: itemTotal,
          
          // totalInclTax:
          //   itemTotal + itemSalesTax + itemExtraTax + itemFurtherTax + itemFedPayable - itemDiscount
        };
      });
  
      // const grandTotal =
      //   totalValues + totalSalesTax + totalFurtherTax + totalExtraTax + totalFedPayable - totalDiscount;
      // console.log(grandTotal)
      const invoice = invoices[0]; // Use first record for static fields
  
      const invoiceDetails = {
        invoiceNo: invoice.FBRSaleInvoiceNo || "",
        date: invoice.invoiceDate,
        docDescription:invoice?.docDescription,
        buyerName: invoice.buyerBusinessName,
        buyerCompany: invoice.buyerBusinessName,
        buyerRegion: invoice.buyerProvince,
        buyerNTN: invoice.buyerNTNCNIC,
        buyerType: invoice.buyerRegistrationType,
        sellerName: invoice.sellerBusinessName,
        buyerAddress: invoice.buyerAddress,
        sellerCompany: invoice.sellerBusinessName,
        sellerAddress: invoice.sellerAddress,
        sellerNTN: invoice.sellerNTNCNIC,
        sellerRegion: invoice.sellerProvince,
        sellerType: invoice?.sellerRegistrationType,
        subTotal: totalvalueSalesExcludingST,
        salesTax: totalSalesTax,
        furtherTax: totalFurtherTax,
        extraTax: totalExtraTax,
        fedPayable: totalFedPayable, 
        discount: totalDiscount,
        quantity: totalQuantity,
        //grandTotal: grandTotal.toFixed(2),
        grandTotal:totalValues,
        grandTotalInWords: convertNumberToWords(totalValues.toFixed(2)) + " Only"
      };
  
      return {
        invoiceDetails,
        invoiceItems
      };
    });
  }
        const handleRedirectContractPreview = async (row) => {
          // setRowSelected(true)
          console.log(row);
          
const records = await getFormattedInvoiceRecords(row.SaleInvoiceID);

if (records) {
const blob = await generateQRCodeBlob(records.invoiceDetails?.invoiceNo);

if (!blob) return;

  console.log("Main Section:",records.invoiceDetails );
  console.log("Detail Section:", records.invoiceItems );
  SaleInvoiceService.SalesTaxInvoiceReport(records.invoiceDetails, records.invoiceItems, blob,'download');
} else {
  console.log("No records returned.");
}

        };
       
       // ==================== SALES TAX  INVOICE -FORMAT 2 =======================
        const handleRedirectContractPreview2 = async (row) => {
          // setRowSelected(true)
          console.log(row);
          
const records = await getFormattedInvoiceRecords(row.SaleInvoiceID);
const getPdfMargins = await securityService.CompanyIP()
let PdfMargins = {
  Left: getPdfMargins.data.recordset[0].LeftMarginInches,
  Right: getPdfMargins.data.recordset[0].RightMarginInches,
  Top: getPdfMargins.data.recordset[0].TopMarginInches,
  Bottom: getPdfMargins.data.recordset[0].BottomMarginInches
}
console.log(PdfMargins)
if (records) {
const blob = await generateQRCodeBlob(records.invoiceDetails?.invoiceNo);

if (!blob) return;

  console.log("Main Section:",records.invoiceDetails );
  console.log("Detail Section:", records.invoiceItems );
  SaleInvoiceService.generateSalesTaxInvoicePDF(records.invoiceDetails, records.invoiceItems, blob,'download',PdfMargins);
} else {
  console.log("No records returned.");
}

        };

//  ======== DIALOG BOX FUNCTIOS SHOW/HIDE =========


const dialogRef = useRef(null);
const showDialog = (
  header = 'WARNING',
  title = ``,
  actions =['OK']) => {
  return new Promise((resolve) => {
  // Destroy existing dialog if any
  if (dialogRef.current) {
    dialogRef.current.destroy();
  }
  const okButtons = actions.map((action) => ({
    buttonModel: {
      content: action,
      cssClass: 'e-flat',
      isPrimary: action === 'OK',
    },
    click: (e) => {
      hideDialog();
      resolve(action);
    },
  }));
  // Create a new dialog instance
  dialogRef.current = new DialogInput({
    content: title =='' ? ()=>(<><span class="error-tooltip">Please select a row first!</span></>): ()=>(<div><br />{title}</div>),
    header:header,
    width:'340px',
      
    showButtons: true,
    buttons:okButtons,
      isModal: true, // Optional: adds a backdrop to focus attention
  });
  // Show the dialog programmatically
    // dialogRef.current.appendTo('#dialog-container');
// dialogRef.current.appendTo('#dialog-container');

  dialogRef.current.show();

});

};
const hideDialog = () =>{
if (dialogRef.current) {
}
dialogRef.current.hide();
dialogRef.current.destroy();
dialogRef.current = null; // Clean up reference after destruction
}



// const dialogRef = useRef(null);
//           const showDialog = () => {
//             // Destroy existing dialog if any
//             if (dialogRef.current) {
//               dialogRef.current.destroy();
//             }
//             const okButtons = [
//               { buttonModel: {content: 'OK',cssClass: 'e-flat',isPrimary: true,},
//                 click: (e) => hideDialog()
//               },];
//             // Create a new dialog instance
//             dialogRef.current = new DialogInput({
//               content: `<span class="error-tooltip">Please select a row first!</span>`,
//               header:'WARNING',
//               width:'300px',
//               showButtons: true,
//               buttons:okButtons
//             });
//             // Show the dialog programmatically
//             dialogRef.current.show();
//           };
//         const hideDialog = () =>{
//           if (dialogRef.current) {
//           }
//           dialogRef.current?.hide();
//           dialogRef.current.destroy();
//           dialogRef.current = null; // Clean up reference after destruction
//         }





        // ======== TOOLBAR CLICKING FUNCTION OF LIST GRID  ==========


        // console.log(grid , args)

        // console.log(selectedRow)

        
        //   if(args?.item?.properties?.id == 'Add'){
        //         grid.addRecord()
        //   }
        //   if(args?.item?.properties?.id == 'SaleInvoicePreview'){
          

        // if(selectedRow == undefined){
        // showDialog()
        // }else{
        //   handleRedirectContractPreview(selectedRow)

        // }

        // }
        // grids.current[Id], args ,grids.current[Id].getSelectedRecords()[0],getListService ,setDataSourceState
    //      console.log(grid , args)

    // console.log(selectedRow)

    
    //   if(args?.item?.properties?.id == 'Add'){
    //         grid.addRecord()
    //   }
    //   if(args?.item?.properties?.id == 'SaleInvoicePreview'){
      

    // if(selectedRow == undefined){
    // showDialog()
    // }else{
    //   handleRedirectContractPreview(selectedRow)

    // }

    // }

  //  const clearToasts = () => {
  //   try {
  //     toastInstance.current?.hide();
  //     toastInstance.current?.clear();
  //   } catch (err) {
  //     console.warn("Toast cleanup failed:", err);
  //   }
  // };


// useEffect(() => {
//   return () => {
//     clearToasts(); // Clean up when component unmounts
//   };
// }, []);
// const toastInstance = useRef(null);

//  const showErrorToast = (errorText ,title , timeOut) => {
//       const errorMessage =
//       errorText ||
//         "Unknown error occurred";
  
//       toastInstance.current.show({
//         title: title || "Validation Error",
//         content: errorMessage,
//         cssClass: "e-toast-danger", // red theme
//         showCloseButton: true,
//         timeOut: timeOut || 30000, // 30 seconds
//         extendedTimeout: 0, // prevent auto-dismiss on hover
//       });
//     };
// const showSuccessToast = (message) => {
//   toastInstance.current.show({
//     title: "Success",
//     content: message || "Data posted successfully",
//     cssClass: "e-toast-success",
//     showCloseButton: true,
//     timeOut: 5000,
//   });
// };


function showAlert({ heading, message, type = 'info', autoClose = 3000, position = 'top-right' }) {
  if (!heading || !message) {
    console.error('❌ showAlert requires both heading and message.');
    return;
  }

  toast[type](
    <div>
      <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px', color: '#000' }}>
        {heading}
      </div>
      <div style={{ fontSize: '14px', color: '#000' }}>
        {message}
      </div>
    </div>,
    {
      position,
      autoClose,
      style: {
        // backgroundColor: '#eee',
        // border: '1px solid #ccc',
        borderRadius: '6px',
        padding: '12px',
      },
    }
  );
}


   const toolbarClicking =  async (grid , args , selectedRow , getListService,setDataSourceState)=>{
            console.log(grid , args)

    console.log(selectedRow)
  
if (args.name === "rowSelected" && selectedRow) {
  const { FBRSaleInvoiceDetailNo } = selectedRow;
  console.log(FBRSaleInvoiceDetailNo);

  const isPostedInvoice = FBRSaleInvoiceDetailNo && FBRSaleInvoiceDetailNo.trim().toUpperCase() !== "NULL";

  // if (!isPostedInvoice) {
  //   // toastInstance.current?.hide();
  //   grid.toolbarModule.enableItems(['Delete'], true);
  // } else {
  //   grid.toolbarModule.enableItems(['Delete'], false);
  //   // showErrorToast(, "Alert", 5000);
  //   showDialog( "Alert","CANNOT DELETE POSTED INVOICES.")
  // }
  if (!isPostedInvoice) {
  // grid.toolbarModule.enableItems(['Delete'], true);
  // grid.toolbarModule.getToolbar().querySelector('[id="RowDelete"]').style.display = 'none';
  
} else {
  // grid.toolbarModule.enableItems(['Delete'], false);
  
  //   grid.toolbarModule.getToolbar().querySelector('[id="RowDelete"]').style.display = 'inline-block';

  //showDialog("Alert", "CANNOT DELETE POSTED INVOICES.");
}

}

    
      if(args?.item?.properties?.id == 'RowDelete'){
      // await showDialog("Alert", "CANNOT DELETE POSTED INVOICES.");
      if (selectedRow) {
  const { FBRSaleInvoiceDetailNo } = selectedRow;
  console.log(FBRSaleInvoiceDetailNo);

  const isPostedInvoice = FBRSaleInvoiceDetailNo && FBRSaleInvoiceDetailNo.trim().toUpperCase() !== "NULL";

  if (!isPostedInvoice) {
    // toastInstance.current?.hide();
                // grid.startEdit()

const attemptDeleteInvoice = async (invoice) => {
  // Check if invoice is posted
  

  // Confirm deletion
  const userChoice = await showDialog(
    "Confirm Delete",
    "Are you sure you want to delete this invoice?",
    ["OK", "Cancel"]
  );

  if (userChoice === "Cancel") {
    // User cancelled, refresh list
    await getListService();
    return;
  }

  // Proceed with deletion
  const result = await SaleInvoiceService.deleteInvoice({SaleInvoiceID:invoice.SaleInvoiceID});
  console.log(result)
  if (result.status == "200" || result.statusText
 == 'OK') {
    // await showDialog("Success", "Invoice deleted successfully.", ["OK"]);
    showAlert({
  heading: 'Success',
  message: 'Invoice deleted successfully.',
  type: 'success',
  autoClose: 5000,
  position: 'bottom-right',
});

         getListService();

  } else {
    // await showDialog("Error", "Unable to delete invoice.", ["OK"]);
      showAlert({
  heading: 'Error',
  message: 'Unable to delete invoice.',
  type: 'error',
  autoClose: 5000,
  position: 'bottom-right',
});
        await getListService();

  }
};
attemptDeleteInvoice(selectedRow)

  } else {
    
    // showErrorToast("CANNOT EDIT POSTED INVOICES.", "Alert", 5000);
      //  await showDialog( "Alert","CANNOT DELETE POSTED INVOICES.",
      // ['OK'])
        showAlert({
  heading: 'Alert',
  message: 'CANNOT DELETE POSTED INVOICES.',
  type: 'info',
  autoClose: 5000,
  position: 'bottom-right',
});
//  getListService();
  }
      }else{
        showDialog()
      }
  
      }
      if(args?.item?.properties?.id == 'EditRow'){
if (selectedRow) {
  const { FBRSaleInvoiceDetailNo } = selectedRow;
  console.log(FBRSaleInvoiceDetailNo);

  const isPostedInvoice = FBRSaleInvoiceDetailNo && FBRSaleInvoiceDetailNo.trim().toUpperCase() !== "NULL";

  if (!isPostedInvoice) {
    // toastInstance.current?.hide();
                grid.startEdit()

  } else {
    
    // showErrorToast("CANNOT EDIT POSTED INVOICES.", "Alert", 5000);
      // await  showDialog( "Alert","CANNOT EDIT POSTED INVOICES.")
        showAlert({
  heading: 'Alert',
  message: 'CANNOT EDIT POSTED INVOICES.',
  type: 'info',
  autoClose: 5000,
  position: 'bottom-right',
});

  }
      }else{
                  showDialog()

      }


    }
      if(args?.item?.properties?.id == 'Add'){
            grid.addRecord()
      }
      if(args?.item?.properties?.id == 'SaleInvoicePreview'){
      
        if(selectedRow == undefined){
          showDialog()
        }else{
          handleRedirectContractPreview(selectedRow)
          
        }
        
      }
      if(args?.item?.properties?.id == 'SaleInvoicePreview2'){
      
        if(selectedRow == undefined){
          showDialog()
        }else{
          handleRedirectContractPreview2(selectedRow)
          
        }
        
      }
        if(args?.item?.properties?.id == 'PostData'){  
  console.log(args?.item?.properties?.id)

  if (selectedRow == undefined) {
    showDialog();
    return;
  }
  // Confirm deletion
  const userChoice = await showDialog(
    "confirmation",
    "Are you sure you want to post this invoice?",
    ["OK", "Cancel"]
  );

  if (userChoice === "Cancel") {
    // User cancelled, refresh list
    await getListService();
    return;
  }

  const { FBRSaleInvoiceDetailNo, SaleInvoiceJSON, SaleInvoiceID } = selectedRow;
  console.log(FBRSaleInvoiceDetailNo)
  if (!FBRSaleInvoiceDetailNo || FBRSaleInvoiceDetailNo === "NULL") {
    try {

      // GET COMPANY ID
        let CompanyResponse = await SaleInvoiceService.getCompanyView()
            
      const parsedData = JSON.parse(SaleInvoiceJSON);
      console.log(parsedData)
      const response = props?.path == "/SaleInvoiceSandbox"  ? await SaleInvoiceService.PostDataTesting(CompanyResponse.data.recordset[0].CompanyID ,parsedData) 
      : await SaleInvoiceService.PostData(CompanyResponse.data.recordset[0].CompanyID ,parsedData);
      console.log(response)
      const validation = response?.data.validationResponse;
      const validInvoiceNumber = response?.data?.invoiceNumber;
      console.log(validation)
      if (validation?.statusCode === "00" && validation?.status === "Valid") {



  const invoiceNumber = validInvoiceNumber;
  const invoiceStatuses = validation.invoiceStatuses;

  // Step 1: Fetch detail records
  const detailListResponse = await SaleInvoiceService.getSaleInvoiceForList(SaleInvoiceID , props?.path == "/SaleInvoiceSandbox" ? 0:1);
  const detailList = detailListResponse.data.recordset || []
  console.log(detailList)
  // Step 2: Match by i ndex (itemSNo is 1-based, array index is 0-based)
        console.log(invoiceStatuses)
  const details = invoiceStatuses.map(status => {
    const index = parseInt(status.itemSNo, 10) - 1;
    const matchedDetail = detailList[index];

    return {
      SaleInvoiceDetailID: matchedDetail?.SaleInvoiceDetailID,
      FBRSaleInvoiceDetailNo: status.invoiceNo
    };
  });
  
  const updatePayload = {
    FBRSaleInvoiceNo: invoiceNumber,
    SaleInvoiceID: selectedRow.SaleInvoiceID,
    details
  };
  console.log(updatePayload)

  // showSuccessToast(`Invoice ${invoiceNumber} posted successfully to FBR.`);
          // showDialog( "Alert",`Invoice ${invoiceNumber} posted successfully to FBR.`)

              showAlert({
  heading: 'Alert',
  message: `Invoice ${invoiceNumber} posted successfully to FBR.`,
  type: 'info',
  autoClose: 5000,
  position: 'bottom-right',
});

  
  console.log(updatePayload);
  let response  = await SaleInvoiceService.updateInvoices(updatePayload);
  if(response.data?.success ==  true){
    getListService()
    // showSuccessToast(`Invoices stored successfully.`);
              // showDialog( "Alert",`Invoices stored successfully.`)
                 showAlert({
  heading: 'Alert',
  message: `Invoices stored successfully.`,
  type: 'info',
  autoClose: 5000,
  position: 'bottom-right',
});


  }

}  else {

  // showErrorToast(validation?.error || "Validation failed");
                // showDialog( "Alert",validation?.error || "Validation failed")
                     showAlert({
  heading: 'Alert',
  message: `validation?.error || "Validation failed"`,
  type: 'error',
  autoClose: 10000,
  position: 'bottom-right',
});

      }
    } catch (error) {
      // showErrorToast(`api error`);
    // showDialog( undefined,`No Response from FBR. Please try again.`)
       showAlert({
  heading: 'Alert',
  message: `No Response from FBR. Please try again.`,
  type: 'error',
  autoClose: 10000,
  position: 'bottom-right',
});

    }
  } else {
    // showErrorToast("This sale invoice has already been posted to FBR");
        // showDialog( "Alert","This sale invoice has already been posted to FBR")

            showAlert({
  heading: 'Alert',
  message: `This sale invoice has already been posted to FBR`,
  type: 'info',
  autoClose: 10000,
  position: 'bottom-right',
});

  }



    
  }
        }
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Count' ,
                    TableID:'CountID',
                   // Optional if Delete is Soft // TableSecurity:'CountDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Count' ,TableID:'CountID', Optional // TableSecurity:'CountDelete'}]
    let listDelete = [{ TableName:['SaleInvoiceDetail','SaleInvoice'] ,TableID:['SaleInvoiceID'],  }];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [{ field: 'FBRSaleInvoiceDetailNo', operator: 'notequal', value: '' }];
      let filterColumnsSaleInvoice = [{ field: 'FBRSaleInvoiceDetailNo', operator: 'equal', value: '' }];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr']; 
      let groupColumns = ['SaleInvoiceID'];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns =  [
  "quantity",
  "valueSalesExcludingST",
  "fixedNotifiedValueOrRetailPrice",
  "salesTaxWithheldAtSource",
  "fedPayable",
  "discount",
  "totalValues"];




    return (
      <>
       {/* <ToastComponent
              ref={toastInstance}
              position={{ X: "Right", Y: "Bottom" }}
            /> */}
             <ToastContainer 
             
              theme="light"
  toastStyle={{
    backgroundColor: '#ffffff',
    color: '#000000',
    border: '1px solid #ccc',
    borderRadius: '6px',
    padding: '12px',
  }}
  />
        <DynamicInputList
        Id='SaleInvoice'
        ListTitle= {props?.path == "/SaleInvoiceSandbox" ? 'Sale Invoice Sandbox - List' :props?.path == "/SaleInvoicePosted" ? 'Sale Invoice POSTED - List' : 'Sale Invoice - List'}
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> SaleInvoiceService.getSaleInvoiceForList(0 , props?.path == "/SaleInvoiceSandbox" ? 0:1)
                        }]}
        DefaultSortedColumnName={'SaleInvoiceID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<InvoiceAdd  GridID ='SaleInvoice' sendDetails={getDetail} isTesting={props?.path == "/SaleInvoiceSandbox" }/>
        
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            ToolbarOption={props?.path == "/SaleInvoicePosted" ? PostedToolbarOptions : toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            // AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            FilterColumns={props?.path == "/SaleInvoicePosted" ? filterColumns : props?.path == "/SaleInvoice" ? filterColumnsSaleInvoice : []} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            GroupColumns={groupColumns} 
            ListDelete={listDelete}
            DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></DynamicInputList>
      

        </>
            );
}



export default SaleInvoiceInput;
